import React from "react"
import tw, { css } from "twin.macro"
import { createGlobalStyle } from "styled-components"

export const SystemFonts = createGlobalStyle`
  ${css`
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Thin-Italic.otf") format("opentype");
      font-weight: 100;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Thin.otf") format("opentype");
      font-weight: 100;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-ExtraLight-Italic.otf") format("opentype");
      font-weight: 200;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-ExtraLight.otf") format("opentype");
      font-weight: 200;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Light-Italic.otf") format("opentype");
      font-weight: 300;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Light.otf") format("opentype");
      font-weight: 300;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Regular-Italic.otf") format("opentype");
      font-weight: 400;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Regular.otf") format("opentype");
      font-weight: 400;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Medium-Italic.otf") format("opentype");
      font-weight: 500;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Medium.otf") format("opentype");
      font-weight: 500;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-SemiBold-Italic.otf") format("opentype");
      font-weight: 600;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-SemiBold.otf") format("opentype");
      font-weight: 600;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Bold-Italic.otf") format("opentype");
      font-weight: 700;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Bold.otf") format("opentype");
      font-weight: 700;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-ExtraBold-Italic.otf") format("opentype");
      font-weight: 800;
      font-style: italic;
    }
    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-ExtraBold.otf") format("opentype");
      font-weight: 800;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Black.otf") format("opentype");
      font-weight: 900;
      font-style: normal;
    }

    @font-face {
      font-family: "Jeko";
      src: url("/fonts/jeko/Jeko-Black-Italic.otf") format("opentype");
      font-weight: 900;
      font-style: italic;
    }
  `}
`
export const ThemeFontFamilyTokens = createGlobalStyle({
  ":root": {
    "--font-family-sans": "Jeko",
    "--font-family-serif": "Jeko",
    "--font-family-mono": "Courier New",
    "--font-family-display": "Jeko",
    "--font-family-body": "Jeko",
  },
})

export const ThemeFontSizeTokens = createGlobalStyle({
  ":root": {
    "--font-size-2xs": "10px",
    "--font-size-xs": "12px",
    "--font-size-sm": "14px",
    "--font-size-md": "16px",
    "--font-size-base": "16px",
    "--font-size-lg": "20px",
    "--font-size-lgm": "20px",
    "--font-size-xl": "24px",
    "--font-size-xlm": "24px",
    "--font-size-2xl": "32px",
    "--font-size-3xl": "40px",
    "--font-size-4xl": "60px",

    "--line-height-xs": "150%",
    "--line-height-sm": "150%",
    "--line-height-md": "150%",
    "--line-height-base": "150%",
    "--line-height-lg": "120%",
    "--line-height-lgm": "120%",
    "--line-height-xl": "120%",
    "--line-height-xlm": "120%",
    "--line-height-2xl": "120%",
    "--line-height-3xl": "120%",
    "--line-height-4xl": "120%",

    "--font-weight-thin": "100",
    "--font-weight-extralight": "200",
    "--font-weight-light": "300",
    "--font-weight-normal": "400",
    "--font-weight-medium": "500",
    "--font-weight-semibold": "600",
    "--font-weight-bold": "700",
    "--font-weight-extrabold": "800",
    "--font-weight-black": "900",
  },
})
